import angular from 'angular';
import { routes } from "./financeiro.routes";
import FinanceiroDirectoryController from "./directory/directory.controller";
import FinanceiroService from "./financeiro.service";
import FinanceiroFaturacaoAutomaticaListView from './faturacaoautomatica/FinanceiroFaturacaoAutomaticaListView';
import FinanceiroFaturacaoSemEmailListView from './faturacaosememail/FinanceiroFaturacaoSemEmailListView';
import { react2angular } from "react18-react2angular";
// `useContext.use(...)` monta o componente por portal dentro do `Root` do
// `<mui-dialog-provider>` (interface/layout/layout.view.html), que traz o
// `ModalProvider` e o `SnackbarProvider`. Sem isto o `useModal()` cai no contexto
// por omissão da biblioteca, cujo `showModal` é uma função vazia — os diálogos não
// aparecem e não há erro nenhum. É a convenção do projeto: outros 41 componentes
// React registam-se assim.
import { useContext } from "@components";
export default angular.module('app.financeiro', [])
    .config(routes)
    .controller('FinanceiroDirectoryController', FinanceiroDirectoryController)
    .component('financeiroFaturacaoAutomaticaListView', react2angular(useContext.use(FinanceiroFaturacaoAutomaticaListView), [], ['CoreFaturacaoAutomatica', 'UIService']))
    .component('financeiroFaturacaoSemEmailListView', react2angular(useContext.use(FinanceiroFaturacaoSemEmailListView), [], ['CoreFaturacaoAutomatica', 'UIService', 'AuthorizationService']))
    .service('FinanceiroService', FinanceiroService)
    .name;
